<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="" prop="用户id">
                <Input type="text" v-model="searchForm.registerId" placeholder="请输入用户id" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="作品名称" prop="workFullname">
                <Input type="text" v-model="searchForm.workFullname" placeholder="请输入作品名称" clearable style="width: 200px"/>
              </Form-item>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="audit" type="primary" icon="md-add">审核</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="700">
      <Form ref="formDetail" :model="formDetail" :label-width="100" :rules="formValidate" >
          <table>
              <tr>
                  <td colspan="4"><h3>作品基本信息</h3></td>
              </tr>
              <tr>
                  <td>作品名称:</td><td>{{this.formDetail.registerOrder.workFullname}}</td>
                  <td>作品类型</td><td>{{this.formDetail.worksExtend.workTypeDesc}}</td>
              </tr>
              <tr>
                  <td>作者:</td><td>{{this.formDetail.worksExtend.authorName}}</td>
                  <td>著作权人:</td><td>{{this.formDetail.worksExtend.powerName}}</td>
              </tr>
              <tr>
                  <td>权利取得:</td><td>{{this.formDetail.worksExtend.powerBy}}</td>
                  <td>权利归属:</td><td>{{this.formDetail.worksExtend.copyrightType}}</td>
              </tr>
              <tr>
                  <td colspan="4"><h3>作品创作信息</h3></td>
              </tr>
              <tr>
                  <td>创作开始时间:</td><td>{{this.formDetail.worksInstruction.completeBegin}}</td>
                  <td>创作完成时间</td><td>{{this.formDetail.worksInstruction.completeDate}}</td>
              </tr>
              <tr>
                  <td>创作地点:</td><td>{{this.formDetail.worksExtend.completeCountry}}-{{this.formDetail.worksExtend.completeProvince}}-{{this.formDetail.worksExtend.completeCity}}</td>
                  <td>修改次数:</td><td>{{this.formDetail.worksInstruction.modifyNumber}}</td>
              </tr>
              <tr>
                  <td colspan="4"><h3>作品发表信息</h3></td>
              </tr>
              <tr>
                  <td>发表状态:</td><td>{{this.formDetail.worksExtend.publishStatus}}</td>
                  <td>首次发表时间</td><td>{{this.formDetail.worksExtend.publishDate}}</td>
              </tr>
              <tr>
                  <td>首次发表地点:</td><td>{{this.formDetail.worksExtend.publishCountry}}-{{this.formDetail.worksExtend.publishProvince}}-{{this.formDetail.worksExtend.publishCity}}</td>
                  <td></td><td></td>
              </tr>
              <tr>
                  <td colspan="4"><h3>创作意图</h3></td>
              </tr>
              <tr>
                  <td colspan="4">{{this.formDetail.worksInstruction.creationIntentions}} </td>
              </tr>
              <tr>
                  <td colspan="4"><h3>作品独创性</h3></td>
              </tr>
              <tr>
                  <td colspan="4">{{this.formDetail.worksInstruction.creationOriginality}} </td>
              </tr>
              <tr>
                  <td colspan="4"><h3>创作声明</h3></td>
              </tr>
              <tr>
                  <td colspan="4">{{this.formDetail.worksExtend.copyrightStatements}} </td>
              </tr>
              <tr>
                  <td colspan="4"><h3>说明文件</h3></td>
              </tr>
              <tr>
                  <td colspan="4">说明文件</td>
              </tr>
              <tr>
                  <td colspan="4"><h3>作品文件</h3></td>
              </tr>
              <tr>
                  <td colspan="4">
                      <span v-for="(n,i) in formDetail.worksAttachmentses"><a :href="''+n.url+''" target="_blank">附件{{i+1}}</a></span>

                  </td>
              </tr>
              <tr>
                  <td colspan="4"><h3>材料信息</h3></td>
              </tr>
              <tr>
                  <td>原创声明</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workStatement}}</td>
              </tr>
              <tr>
                  <td>创作说明</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workInstruction}}</td>
              </tr>
              <tr>
                  <td>合作创作证明</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workCooperationThat}}</td>
              </tr>
              <tr>
                  <td>法人作品申明</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workCorporate}}</td>
              </tr>
              <tr>
                  <td>职务作品证明</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workJobProduction}}</td>
              </tr>
              <tr>
                  <td>委托开发合同</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workJobProduction}}</td>
              </tr>
              <tr>
                  <td>委托作品声明</td>
                  <td colspan="3">{{this.formDetail.worksExtend.workJobProduction}}</td>
              </tr>
          </table>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "CopyrightRegisterOrder",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "create_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      formDetail: {
          registerOrder: [],
          worksExtend: [],
          worksInstruction: [],
          worksAttachmentses: {},
          authors: {},
          powers: {},
      },
      form: { // 详情数据
        id: "",
        remarks: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "订单序列号",
          key: "orderSeqNo",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "用户ID",
          key: "registerId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品名称",
          key: "workFullname",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单状态",
          key: "orderStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "订单提交时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证书编码",
          key: "certCode",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "发证时间",
          key: "cerTime",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.orderSeqNo);
                    }
                  }
                },
                "预览"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
       this.getRequest("/copyrightregister/getByPage", this.searchForm).then(res => {
         this.loading = false;
         if (res.success) {
           this.data = res.result.records;
           this.total = res.result.total;
         }
       });
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
        }
      });
    },
    detail(orderSeqNo) {
      this.modalType = 1;
      this.modalTitle = "详情";
      this.getRequest("/copyrightregister/getDetail?orderSeqNo="+orderSeqNo).then(res => {
        this.loading = false;
        if (res.success) {
          this.formDetail = res.result;
          this.modalVisible = true;
        }
      });

    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>